module.exports = __webpack_public_path__ + "img/20200106160607360截图20200106111050211.5735295a.jpg";